import { errorSnackbar } from '@/core/service/utils'

export default {
  data: () => ({
    isLoadingAutoCompleteTipoComissoes: false,
    searchTextTipoComissoes: null,
  }),

  methods: {
    searchAutoCompleteTiposComissoes() {
      clearTimeout(this.debounce)
      const vm = this
      this.debounce = setTimeout(() => {
        if (vm.searchTextTipoComissoes === null || vm.searchTextTipoComissoes.length === 0) {
          vm.searchTextTiposComissoes('')
          return
        }
        
        vm.searchTextTiposComissoes(vm.searchTextTipoComissoes)
      }, 600)
    },

    searchTextTiposComissoes (val) {
      this.isLoadingAutoCompleteTipoComissoes = true
      this.getComissions({ 
        _filter: { "ComissionTypes:iccid_ilike":`${val}%` }
      })
      .catch(err => {
        errorSnackbar(err.error)
      })
      .finally(() => this.isLoadingAutoCompleteTipoComissoes = false)
    }
  }
}